import {Map} from "@dropDesk/domain/entities/ticket/ticket_maps";

export const inactivityMap: Map<number>[] = [
    {value: 30, label: "Entre 30/35 minutos"},
    {value: 45, label: "Entre 45/50 minutos"},
    {value: 60, label: "Entre 60/65 minutos"},
];

export const inactivityTransferSectorMap: Map<number>[] = [
    {value: 5, label: "Entre 5/10 minutos"},
    {value: 10, label: "Entre 10/15 minutos"},
    {value: 15, label: "Entre 15/20 minutos"},
    {value: 20, label: "Entre 20/25 minutos"},
    {value: 30, label: "Entre 30/35 minutos"},
];

export const evaluationAttemptsMap: Map<number>[] = [
    {value: 1, label: "1 tentativa"},
    {value: 2, label: "2 tentativas"},
    {value: 3, label: "3 tentativas"},
    {value: 4, label: "4 tentativas"},
    {value: 5, label: "5 tentativas"},
];
